import React from 'react';
import styled from 'styled-components';
import { ISignificanceQueryFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../utils/formatting';
import { theme } from '../../../styles/theme';

interface IProps {
  builderInfo: ISignificanceQueryFieldsFragment;
}

const Container = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;
const HighlightedText = styled.span`
  padding-right: 3px;
  padding-left: 3px;
  font-weight: 600;
`;

const SignificanceChartTestInfo = ({ builderInfo }: IProps) => {
  const { test, confidenceLevel, significanceLevel } = builderInfo;

  return (
    <Container>
      Analysis on
      <HighlightedText>{test.name}</HighlightedText>
      Hypothesis Test with a P-Value of
      <HighlightedText>
        {globalFormat.formatNumber(
          significanceLevel,
          defaultNumberFormatOptions.decimal,
        )}
      </HighlightedText>
      while maintaining a<HighlightedText>{confidenceLevel}%</HighlightedText>
      Confidence Level
    </Container>
  );
};

export default SignificanceChartTestInfo;
